import { C } from "../data/content";

export const Transformation = () => (
  <section className="py-28 px-6 lg:px-12" style={{ background: "rgba(255,255,255,0.015)" }} data-testid="transformation-section">
    <div className="max-w-[1200px] mx-auto grid md:grid-cols-2 gap-16">
      <div>
        <p className="mono text-[11px] tracking-[0.25em] text-[var(--accent)] mb-6">[006] — SOUND FAMILIAR?</p>
        <h2 className="h1-display text-[clamp(26px,3vw,42px)] mb-8 normal-case" style={{ textTransform: "none", letterSpacing: "-0.02em" }}>
          If You're Like Most VA-Eligible Buyers I Work With...
        </h2>
        <div className="space-y-5 text-[15px] text-white/55 leading-[1.8]">
          <p>
            ...you've probably already hit a wall or two. Maybe a lender told you "not yet" without ever explaining why. Maybe you filled out an online form and waited a week for a generic answer that told you nothing about your actual entitlement. Meanwhile, homes you liked went under contract to someone else.
          </p>
          <p>
            And the worst part is the confusion — everyone has an opinion on what matters. Your credit score? Your down payment? Your DTI? You end up guessing about the single biggest purchase of your life, when the truth is your real VA number is knowable — this week, without a hard pull.
          </p>
        </div>
      </div>
      <div className="md:pt-20">
        <p className="mono text-[12px] tracking-[0.2em] text-[var(--accent)] mb-8">HERE'S WHAT CHANGES AFTER THIS WEBINAR:</p>
        <ul className="space-y-6">
          {C.transforms.map((t, i) => (
            <li key={i} className="flex gap-4 items-start" data-testid={`transform-bullet-${i + 1}`}>
              <span className="text-[var(--accent)] font-black text-lg">→</span>
              <p className="text-[15px] text-white/75 font-medium leading-relaxed">{t}</p>
            </li>
          ))}
        </ul>
        <button className="btn-accent cta mt-12" data-testid="transformation-cta"
          onClick={() => document.getElementById("register")?.scrollIntoView({ behavior: "smooth" })}>
          ✓ RESERVE MY FREE SEAT
        </button>
      </div>
    </div>
  </section>
);
